import * as React from "react";
const SvgGeoposition = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.277a7.723 7.723 0 1 0 0 15.446 7.723 7.723 0 0 0 0-15.446M2.872 12a9.128 9.128 0 1 1 18.256 0 9.128 9.128 0 0 1-18.256 0",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1c.388 0 .702.314.702.702v3.745a.702.702 0 1 1-1.404 0V1.702c0-.388.314-.702.702-.702M17.851 12c0-.388.314-.702.702-.702h3.745a.702.702 0 0 1 0 1.404h-3.745a.7.7 0 0 1-.702-.702M12 17.851c.388 0 .702.314.702.702v3.745a.702.702 0 0 1-1.404 0v-3.745c0-.388.314-.702.702-.702M1 12c0-.388.314-.702.702-.702h3.745a.702.702 0 1 1 0 1.404H1.702A.7.7 0 0 1 1 12M12 11.766a.234.234 0 1 0 0 .468.234.234 0 0 0 0-.468M10.362 12a1.638 1.638 0 1 1 3.276 0 1.638 1.638 0 0 1-3.276 0",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 12.936a.936.936 0 1 0 0-1.872.936.936 0 0 0 0 1.872"
  }
));
export default SvgGeoposition;
